// extracted by mini-css-extract-plugin
export default {"settings":"SettingsPage_settings__5KTi1"};